import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CommonService } from './common.service';
import { MessageService } from './message.service';

import { environment } from '../../environments/environment';

@Injectable()
export class YoyakuMasterService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) { }

  private httpOptions = this.commonService.httpOptions;
  private Options  = this.commonService.Options;
  


    //時間軸リストマスタ
    getTimeaxisList (param:any){
      this.commonService.loadingStart();
      return this.http.get(environment.apiUrl+'/api/ymaster/timeaxislist/timeaxis_list_all/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('timeaxis_list', []))
        );
    }
    saveTimeaxisList (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/timeaxislist/save_timeaxis_list',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('saveTimeaxis', []))
        );
    }
    updateTimeaxisList (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/timeaxislist/update_timeaxis_list',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('updateLanguage', []))
        );
    }
    deleteTimeaxisList (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/timeaxislist/delete_timeaxis_list',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('deleteLanguage', []))
        );
    }
    changeOrderTimeaxisList (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/timeaxislist/timeaxis_list_order',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('updateL', []))
        );
    }
    //時間軸マスタ
    getTimeaxis (tid:number){
      this.commonService.loadingStart();
      return this.http.get(environment.apiUrl+'/api/ymaster/timeaxis/timeaxis_all/'+ tid,this.httpOptions)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('timeaxis', []))
        );
    }
    saveTimeaxis (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/timeaxis/save_timeaxis',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('saveTimeaxis', []))
        );
    }
    updateTimeaxis (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/timeaxis/update_timeaxis',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('updateLanguage', []))
        );
    }
    deleteTimeaxis (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/timeaxis/delete_timeaxis',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('deleteLanguage', []))
        );
    }
    changeOrderTimeaxis (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/timeaxis/timeaxis_order',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('updateL', []))
        );
    }
 //区分１マスタ
    getDivision1 (param:any){
      this.commonService.loadingStart();
      return this.http.get(environment.apiUrl+'/api/ymaster/division1/division1_all',this.httpOptions)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('division1_list', []))
        );
    }
    save (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/division1/save',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('saveD', []))
        );
    }
    
    delete (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/division1/delete',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('deleteDivision', []))
        );
    }
    changeOrderDivision1 (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/division1/division1_order',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('updateD', []))
        );
    }
   //区分2マスタ
   getDivision2 (did:number){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/ymaster/division2/division2_all/' + did,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('division2_list', []))
      );
  }
  saveDivision2 (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/ymaster/division2/save',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveD', []))
      );
  }
  
  deleteDivision2 (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/ymaster/division2/delete',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteDivision2', []))
      );
  }
  changeOrderDivision2 (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/ymaster/division2/division2_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('updateD', []))
      );
  }
  //条件（小）マスタ
  getConditions (){
  this.commonService.loadingStart();
  return this.http.get(environment.apiUrl+'/api/ymaster/condition/condition_list_all/',this.httpOptions)
    .pipe(
      tap(Response => this.commonService.loadingEnd()),
      catchError(this.commonService.handleError('condition_list', []))
    );
  }
  saveConditions (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/ymaster/condition/save_s',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('save_condition', []))
      );
  }
  deleteConditions (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/ymaster/condition/delete_s',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('delete_condition', []))
      );
  }
  changeOrderCondition (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/ymaster/condition/condition_s_order',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('update_condition', []))
      );
  }
  //条件（中）マスタ
  getConditionsM (){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/ymaster/condition/condition_list_m_all/',this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('condition_list', []))
      );
    }
    saveConditionsM (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/condition/save_m',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('save_condition', []))
        );
    }
    deleteConditionsM (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/condition/delete_m',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('delete_condition', []))
        );
    }
    changeOrderConditionM (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/condition/condition_m_order',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('update_condition', []))
        );
    }
  //条件（大）マスタ
  getConditionsL (){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/ymaster/condition/condition_list_l_all/',this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('condition_list', []))
      );
    }
    saveConditionsL (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/condition/save_l',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('save_condition', []))
        );
    }
    deleteConditionsL (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/condition/delete_l',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('delete_condition', []))
        );
    }
    changeOrderConditionL (param:any){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl+'/api/ymaster/condition/condition_l_order',param,this.Options)
        .pipe(
          tap(Response => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError('update_condition', []))
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/service/ymaster.service.ts